import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { Breadcrumbs } from '../../components/shared';
import AreaTaxLocationsTab from './AreaTaxLocationsTab';
import { useManageAreaTaxLocation } from './hooks';

const ManageAreaTaxLocation = () => {
  const theme = useTheme();

  const { breadcrumbData, currentTotalCount, handleTotalCountUpdate } = useManageAreaTaxLocation();

  return (
    <>
      <Box>
        <Breadcrumbs variant="body2" underline="hover" data={breadcrumbData || []} />
      </Box>
      <React.Fragment>
        <Typography mt="34px" variant="h1">
          Manage Area Tax Location
        </Typography>
        <Typography variant="h3" sx={{ color: theme?.palette?.secondary?.main }}>
          {`${currentTotalCount ?? 0} Locations`}
        </Typography>
        <Box component={Paper} pt={2} mt={2}>
          <AreaTaxLocationsTab status="all" isActiveTab={true} onTotalCount={handleTotalCountUpdate} />
        </Box>
      </React.Fragment>
    </>
  );
};

export default ManageAreaTaxLocation;
